import React,{useState,useEffect,useCallback} from "react";

import { Container, ContainerLoading, Content, Table,Button } from "./styles";
import { formatMoney } from "../../../../Utils/formatMoney";
import { toast } from "react-toastify";

import { SpaceLoader } from "../../../loaders/spaceLoader";
import { ButtonExportExcel } from "../buttonExportExcel";

import { api } from "../../../../services/api";
import { useAdministrativeContext } from "../../../../pages/administrativePanel/administrativePanelContext";
import { download_csv } from "../centralizedModal/JsonToCsv";

export function SalesChannelBilling(){

    const {
        startDate,
        endDate,
        listBusinessToFilter,
        listSalesChannelsId
    } = useAdministrativeContext();

    const [sales,setSales] = useState([]);
    const [page,setPage] = useState(1);
    const [loading,setLoading] = useState(true);
    const [loadingButton,setLoadingButton] = useState(false);
    const [open,setOpen] = useState(false);

    useEffect(() => {
        async function loadSales(){
            setLoading(true)
            try{
                const response = await api.post('/getSalesChannelBilling?page=1',{
                    business: listBusinessToFilter,
                    salesChannels: listSalesChannelsId,
                    startDate,
                    endDate
                })
                
                const {data,next_page} = response.data
                // console.log(response.data)

                setSales(data);
                setPage(next_page);
                setLoading(false);
            }
            catch(error){
                // console.log(error)
                setLoading(false)
            }
        }
        loadSales();
    },[endDate,listBusinessToFilter,listSalesChannelsId,startDate]);

    const handleNewData = useCallback(async () => {
        setLoadingButton(true)
        try{
            const response = await api.post(`/getSalesChannelBilling?page=${page}`,{
                business: listBusinessToFilter,
                salesChannels: listSalesChannelsId,
                startDate,
                endDate
            })

            const {data,next_page} = response.data
            // console.log(response.data)

            setSales([...sales,...data]);
            setPage(next_page);
            setLoadingButton(false);
        }
        catch(error){
            //console.log(error)
            setLoadingButton(false)
        }
    },[sales,endDate,listBusinessToFilter,listSalesChannelsId,page,startDate]);

    async function handleDownloadCSV(){
        setLoading(true)
        try{
            const response = await api.post('/getSalesChannelBilling?page=0',{
                business: listBusinessToFilter,
                salesChannels: listSalesChannelsId,
                startDate,
                endDate
            })
            
            const {data} = response.data
            //console.log(data)

            let newArr = data.map((item) => {
                let arr = Object.entries(item).slice(8).map((item) => {
                    return item
                })
                .reduce((value,next,index) => {
                    value[next[0].replace(' ','')] = Number(next[1]).toFixed(2).replace('.',',')
                    return value
                },{})
    
                return{
                    id: item.cdEmpresa,
                    id_Customized: item.idCustomized,
                    CNPJ: item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"),
                    Empresa: item.dsEmpresa,
                    Municipio: item.dsMunicipio,
                    Estado: item.dsUf,
                    ...arr,
                    Valor_Acumulado: Number(Object.entries(item).slice(8).map((value) => {
                        return value[1]
                    })
                    .reduce((value,next) => {
                        return value + next
                    })).toFixed(2),
                    Ticket_Medio: Number(item.ticketMedio).toFixed(2).replace('.',','),
                }
            })
    
            //console.log(newArr)
            download_csv(newArr, 'Faturamento por Canal de Venda')
            setOpen(false)
            setLoading(false);
        }
        catch(error){
            toast.error('Ops, algo deu errado !!');
            setLoading(false)
        }
    }

    if(loading){
        return (
            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }

    return(
        <Container>
            <ButtonExportExcel
                open={open}
                setOpen={setOpen}
                handleDownloadCSV={handleDownloadCSV}
            />

            <Content>
                <Table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>ID Customizado</th>
                            <th className="header-fixed">Empresa</th>
                            
                            {
                                sales !== undefined && Object.entries(sales[0]).slice(8).map((value,index) => {
                                    return <th>{value[0]}</th>
                                })
                            }

                            <th>Valor</th>
                            <th>Ticket Médio</th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            sales?.map((item,index) => {
                                return(
                                    <tr key={item.cdEmpresa}>
                                        <td>{item.cdEmpresa}</td>
                                        <td>{item.idCustomized}</td>
                                        <td className="body-fixed">{item.dsEmpresa}</td>
                                        {
                                            Object.entries(item).slice(8)
                                            .map((value) => {
                                                return <td>{formatMoney(value[1])}</td>
                                            })
                                        }

                                        <td>
                                            {
                                                formatMoney(
                                                    Object.entries(item).slice(8)
                                                    .map((value) => {
                                                        return value[1]
                                                    })
                                                    .reduce((value,next) => {
                                                        return value + next
                                                    })
                                                )
                                            }
                                        </td>
                                        <td>{formatMoney(item.ticketMedio)}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </Content>

            {
                page !== null &&
                <Button onClick={handleNewData} 
                loadingButton={loadingButton}
                >
                    {
                        loadingButton ?
                            '...aguarde'
                            :
                            'Ver mais'
                    }
                </Button>
            }
        </Container>
    )
}